import { forwardRef } from "react";
import type { AppIcon } from "../types";

export const ListIcon = forwardRef<SVGSVGElement, AppIcon>(
  ({ width = 16, height = 16, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={width}
        height={height}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M2.33331 6.33337C2.33331 6.51019 2.40355 6.67975 2.52858 6.80478C2.6536 6.9298 2.82317 7.00004 2.99998 7.00004C3.17679 7.00004 3.34636 6.9298 3.47138 6.80478C3.59641 6.67975 3.66665 6.51019 3.66665 6.33337C3.66665 6.15656 3.59641 5.98699 3.47138 5.86197C3.34636 5.73695 3.17679 5.66671 2.99998 5.66671C2.82317 5.66671 2.6536 5.73695 2.52858 5.86197C2.40355 5.98699 2.33331 6.15656 2.33331 6.33337Z"
          stroke="#1677FF"
        />
        <path
          d="M5.66665 3.00004C5.66665 3.17685 5.73688 3.34642 5.86191 3.47145C5.98693 3.59647 6.1565 3.66671 6.33331 3.66671C6.51012 3.66671 6.67969 3.59647 6.80472 3.47145C6.92974 3.34642 6.99998 3.17685 6.99998 3.00004C6.99998 2.82323 6.92974 2.65366 6.80472 2.52864C6.67969 2.40361 6.51012 2.33337 6.33331 2.33337C6.1565 2.33337 5.98693 2.40361 5.86191 2.52864C5.73688 2.65366 5.66665 2.82323 5.66665 3.00004Z"
          stroke="#1677FF"
        />
        <path
          d="M5.66665 9.66671C5.66665 9.84352 5.73688 10.0131 5.86191 10.1381C5.98693 10.2631 6.1565 10.3334 6.33331 10.3334C6.51012 10.3334 6.67969 10.2631 6.80472 10.1381C6.92974 10.0131 6.99998 9.84352 6.99998 9.66671C6.99998 9.4899 6.92974 9.32033 6.80472 9.1953C6.67969 9.07028 6.51012 9.00004 6.33331 9.00004C6.1565 9.00004 5.98693 9.07028 5.86191 9.1953C5.73688 9.32033 5.66665 9.4899 5.66665 9.66671Z"
          stroke="#1677FF"
        />
        <path
          d="M2.33331 13C2.33331 13.1769 2.40355 13.3464 2.52858 13.4714C2.6536 13.5965 2.82317 13.6667 2.99998 13.6667C3.17679 13.6667 3.34636 13.5965 3.47138 13.4714C3.59641 13.3464 3.66665 13.1769 3.66665 13C3.66665 12.8232 3.59641 12.6537 3.47138 12.5286C3.34636 12.4036 3.17679 12.3334 2.99998 12.3334C2.82317 12.3334 2.6536 12.4036 2.52858 12.5286C2.40355 12.6537 2.33331 12.8232 2.33331 13Z"
          stroke="#1677FF"
        />
        <path
          d="M8.99998 6.33337C8.99998 6.51019 9.07022 6.67975 9.19524 6.80478C9.32027 6.9298 9.48984 7.00004 9.66665 7.00004C9.84346 7.00004 10.013 6.9298 10.1381 6.80478C10.2631 6.67975 10.3333 6.51019 10.3333 6.33337C10.3333 6.15656 10.2631 5.98699 10.1381 5.86197C10.013 5.73695 9.84346 5.66671 9.66665 5.66671C9.48984 5.66671 9.32027 5.73695 9.19524 5.86197C9.07022 5.98699 8.99998 6.15656 8.99998 6.33337Z"
          stroke="#1677FF"
        />
        <path
          d="M12.3333 3.00004C12.3333 3.17685 12.4036 3.34642 12.5286 3.47145C12.6536 3.59647 12.8232 3.66671 13 3.66671C13.1768 3.66671 13.3464 3.59647 13.4714 3.47145C13.5964 3.34642 13.6666 3.17685 13.6666 3.00004C13.6666 2.82323 13.5964 2.65366 13.4714 2.52864C13.3464 2.40361 13.1768 2.33337 13 2.33337C12.8232 2.33337 12.6536 2.40361 12.5286 2.52864C12.4036 2.65366 12.3333 2.82323 12.3333 3.00004Z"
          stroke="#1677FF"
        />
        <path
          d="M8.99998 13C8.99998 13.1769 9.07022 13.3464 9.19524 13.4714C9.32027 13.5965 9.48984 13.6667 9.66665 13.6667C9.84346 13.6667 10.013 13.5965 10.1381 13.4714C10.2631 13.3464 10.3333 13.1769 10.3333 13C10.3333 12.8232 10.2631 12.6537 10.1381 12.5286C10.013 12.4036 9.84346 12.3334 9.66665 12.3334C9.48984 12.3334 9.32027 12.4036 9.19524 12.5286C9.07022 12.6537 8.99998 12.8232 8.99998 13Z"
          stroke="#1677FF"
        />
        <path
          d="M12.3333 9.66671C12.3333 9.84352 12.4036 10.0131 12.5286 10.1381C12.6536 10.2631 12.8232 10.3334 13 10.3334C13.1768 10.3334 13.3464 10.2631 13.4714 10.1381C13.5964 10.0131 13.6666 9.84352 13.6666 9.66671C13.6666 9.4899 13.5964 9.32033 13.4714 9.1953C13.3464 9.07028 13.1768 9.00004 13 9.00004C12.8232 9.00004 12.6536 9.07028 12.5286 9.1953C12.4036 9.32033 12.3333 9.4899 12.3333 9.66671Z"
          stroke="#1677FF"
        />
        <path
          d="M2.33331 6.33337C2.33331 6.51019 2.40355 6.67975 2.52858 6.80478C2.6536 6.9298 2.82317 7.00004 2.99998 7.00004C3.17679 7.00004 3.34636 6.9298 3.47138 6.80478C3.59641 6.67975 3.66665 6.51019 3.66665 6.33337C3.66665 6.15656 3.59641 5.98699 3.47138 5.86197C3.34636 5.73695 3.17679 5.66671 2.99998 5.66671C2.82317 5.66671 2.6536 5.73695 2.52858 5.86197C2.40355 5.98699 2.33331 6.15656 2.33331 6.33337Z"
          stroke="#1677FF"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.66665 3.00004C5.66665 3.17685 5.73688 3.34642 5.86191 3.47145C5.98693 3.59647 6.1565 3.66671 6.33331 3.66671C6.51012 3.66671 6.67969 3.59647 6.80472 3.47145C6.92974 3.34642 6.99998 3.17685 6.99998 3.00004C6.99998 2.82323 6.92974 2.65366 6.80472 2.52864C6.67969 2.40361 6.51012 2.33337 6.33331 2.33337C6.1565 2.33337 5.98693 2.40361 5.86191 2.52864C5.73688 2.65366 5.66665 2.82323 5.66665 3.00004Z"
          stroke="#1677FF"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.66665 9.66671C5.66665 9.84352 5.73688 10.0131 5.86191 10.1381C5.98693 10.2631 6.1565 10.3334 6.33331 10.3334C6.51012 10.3334 6.67969 10.2631 6.80472 10.1381C6.92974 10.0131 6.99998 9.84352 6.99998 9.66671C6.99998 9.4899 6.92974 9.32033 6.80472 9.1953C6.67969 9.07028 6.51012 9.00004 6.33331 9.00004C6.1565 9.00004 5.98693 9.07028 5.86191 9.1953C5.73688 9.32033 5.66665 9.4899 5.66665 9.66671Z"
          stroke="#1677FF"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.33331 13C2.33331 13.1769 2.40355 13.3464 2.52858 13.4714C2.6536 13.5965 2.82317 13.6667 2.99998 13.6667C3.17679 13.6667 3.34636 13.5965 3.47138 13.4714C3.59641 13.3464 3.66665 13.1769 3.66665 13C3.66665 12.8232 3.59641 12.6537 3.47138 12.5286C3.34636 12.4036 3.17679 12.3334 2.99998 12.3334C2.82317 12.3334 2.6536 12.4036 2.52858 12.5286C2.40355 12.6537 2.33331 12.8232 2.33331 13Z"
          stroke="#1677FF"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.99998 6.33337C8.99998 6.51019 9.07022 6.67975 9.19524 6.80478C9.32027 6.9298 9.48984 7.00004 9.66665 7.00004C9.84346 7.00004 10.013 6.9298 10.1381 6.80478C10.2631 6.67975 10.3333 6.51019 10.3333 6.33337C10.3333 6.15656 10.2631 5.98699 10.1381 5.86197C10.013 5.73695 9.84346 5.66671 9.66665 5.66671C9.48984 5.66671 9.32027 5.73695 9.19524 5.86197C9.07022 5.98699 8.99998 6.15656 8.99998 6.33337Z"
          stroke="#1677FF"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.3333 3.00004C12.3333 3.17685 12.4036 3.34642 12.5286 3.47145C12.6536 3.59647 12.8232 3.66671 13 3.66671C13.1768 3.66671 13.3464 3.59647 13.4714 3.47145C13.5964 3.34642 13.6666 3.17685 13.6666 3.00004C13.6666 2.82323 13.5964 2.65366 13.4714 2.52864C13.3464 2.40361 13.1768 2.33337 13 2.33337C12.8232 2.33337 12.6536 2.40361 12.5286 2.52864C12.4036 2.65366 12.3333 2.82323 12.3333 3.00004Z"
          stroke="#1677FF"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.99998 13C8.99998 13.1769 9.07022 13.3464 9.19524 13.4714C9.32027 13.5965 9.48984 13.6667 9.66665 13.6667C9.84346 13.6667 10.013 13.5965 10.1381 13.4714C10.2631 13.3464 10.3333 13.1769 10.3333 13C10.3333 12.8232 10.2631 12.6537 10.1381 12.5286C10.013 12.4036 9.84346 12.3334 9.66665 12.3334C9.48984 12.3334 9.32027 12.4036 9.19524 12.5286C9.07022 12.6537 8.99998 12.8232 8.99998 13Z"
          stroke="#1677FF"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.3333 9.66671C12.3333 9.84352 12.4036 10.0131 12.5286 10.1381C12.6536 10.2631 12.8232 10.3334 13 10.3334C13.1768 10.3334 13.3464 10.2631 13.4714 10.1381C13.5964 10.0131 13.6666 9.84352 13.6666 9.66671C13.6666 9.4899 13.5964 9.32033 13.4714 9.1953C13.3464 9.07028 13.1768 9.00004 13 9.00004C12.8232 9.00004 12.6536 9.07028 12.5286 9.1953C12.4036 9.32033 12.3333 9.4899 12.3333 9.66671Z"
          stroke="#1677FF"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
